import { Stack } from "@mantine/core";
import React from "react";

export default function SubTopicResourceWrapper({
  children,
  isPreview,
}: {
  children: React.ReactNode;
  isPreview?: true;
}) {
  return (
    <Stack
      align="center"
      mt={isPreview ? "0" : "xl"}
      mb={isPreview ? "xl" : "10rem"}
      mih={isPreview ? "50vh" : undefined}
    >
      {children}
    </Stack>
  );
}
